import styled from 'styled-components';
import { getThemeProp } from 'styles/theme';
import { colors } from '@omilia/theme';
import { IconButton } from '@omilia/button';
import {
  AttachIcon,
  EyeIcon,
  EyeSlashIcon,
  NotificationWarningIcon,
} from '@omilia/icon';
import Tooltip from '@omilia/tooltip';

export const SForm = styled.form<{
  isSensitiveInput?: boolean;
  withEmoji: boolean;
  withFooter: boolean;
}>`
  align-items: center;
  background-color: ${({ isSensitiveInput }) =>
    isSensitiveInput ? colors.COLOR_ORANGE_100 : colors.COLOR_WHITE};
  border: ${({ isSensitiveInput }) =>
    isSensitiveInput
      ? `2px solid ${colors.COLOR_ORANGE_300}`
      : `1px solid ${colors.COLOR_GREY_400}`};
  border-radius: 32px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: ${({ withFooter }) =>
    withFooter ? '0 16px 12px 16px' : '0 16px 40px 16px'};
  min-height: 53px;
  padding: 9px 16px;
  position: relative;
  width: auto;
`;

export const SFormInnerContainer = styled.div`
  align-items: center;
  box-sizing: border-box;
  display: flex;
  gap: 8px;
  width: 100%;
`;

export const SInputPrefix = styled.span`
  align-items: center;
  display: flex;
  flex-shrink: 0;
`;

export const SInput = styled.textarea<{
  isIOS: boolean;
  isSensitiveInput?: boolean;
}>`
  background-color: transparent;
  border: none !important;
  box-shadow: none !important;
  color: ${colors.COLOR_GREY_1000};
  flex: 1;
  font-family: ${getThemeProp('fontFamily')};
  font-size: ${({ isIOS, isSensitiveInput }) =>
    isIOS || isSensitiveInput ? '16px' : '14px'};
  height: 20px;
  line-height: 20px;
  max-height: 100px;
  min-width: 0;
  padding: 0;
  resize: none;
  width: 100%;

  &:focus {
    outline: none;
  }

  &::-webkit-input-placeholder {
    color: ${colors.COLOR_GREY_800};
  }

  /* Hide Edge/IE native password reveal and clear buttons */
  &::-ms-reveal,
  &::-ms-clear {
    display: none;
  }

  &::placeholder {
    font-size: 14px;
    color: ${colors.COLOR_GREY_800};
  }

  &[disabled] {
    background-color: transparent;
  }
`;

export const SFooter = styled.div`
  background-color: ${colors.COLOR_WHITE};
  border-radius: 0 0 24px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

export const SHiddenLabel = styled.span`
  display: block;
  height: 0;
  visibility: hidden;
  width: 0;
`;

export const SEmojiPickerContainer = styled.div`
  bottom: 85px;
  left: 16px;
  position: absolute;

  aside.EmojiPickerReact.epr-main {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }

  .epr-category-nav {
    display: none;
  }
`;

export const SEmojiIcon = styled(IconButton)`
  cursor: ${({ disabled }) => (disabled ? 'initial' : 'pointer')};
  margin-right: 4px;

  &:disabled {
    opacity: 1;
  }

  &:hover {
    background: none;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const SAttachLabel = styled.label`
  align-items: center;
  display: flex;
  margin-right: 4px;
`;

export const SAttachIcon = styled(AttachIcon)<{ disabled?: boolean }>`
  cursor: ${({ disabled }) => (disabled ? 'auto' : 'pointer')};
`;

export const SRevealButton = styled.button`
  align-items: center;
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-shrink: 0;
  padding: 0;

  &:focus {
    outline: none;
  }
`;

export const SEyeIcon = styled(EyeIcon)`
  cursor: pointer;
`;

export const SEyeSlashIcon = styled(EyeSlashIcon)`
  cursor: pointer;
`;

export const STooltip = styled(Tooltip)`
  font-family: ${getThemeProp('fontFamily')};
`;

export const SFilesContainer = styled.div`
  max-height: 145px;
  overflow: auto;
  padding: 2px;
  width: 100%;
  margin-bottom: 16px;
`;

export const SMaxFilesError = styled.div`
  align-items: center;
  background-color: ${colors.COLOR_RED_100};
  border-radius: 24px;
  border: 1px solid ${colors.COLOR_RED_300};
  display: flex;
  justify-content: space-between;
  padding: 12px;

  span {
    color: ${colors.COLOR_RED_800};
    font-size: 12px;
  }
`;

export const SNotificationWarningIcon = styled(NotificationWarningIcon)`
  margin-right: 8px;
  min-width: 20px;
`;
